import get from 'lodash/get';
import { createAction } from 'redux-actions';
import { parseJwt } from '../../../util/helpers';
import { CALL_API } from '../constants';

const toSession = data => {
  const expires = get(data, 'expires');
  const token = get(data, 'token');
  const parsedToken = JSON.parse(parseJwt(token));

  return {
    expires,
    token,
    user: {
      firstName: parsedToken.FirstName,
      id: parsedToken.Id,
      isAdmin: parsedToken.IsAdmin,
      lastName: parsedToken.LastName,
      email: parsedToken.Email,
      unique_name: parsedToken.unique_name,
    },
  };
};

const getErrorText = error => {
  const text = get(error, ['body', 'error']);
  return (
    text ||
    'There was a problem connecting to the server. Please check your internet connection, and contact a Palliative Care Coalition administrator if the problem persists.'
  );
};

const SessionService = {
  create: createAction(CALL_API, (email, password) => ({
    body: { email, password },
    method: 'POST',
    path: '/auth',
    handleResponse: toSession,
    handleError: error => Promise.reject(getErrorText(error)),
  })),

  createWithSocial: createAction(CALL_API, (platform, thirdPartyToken) => ({
    body: { thirdPartyToken },
    method: 'POST',
    path: `/auth/${platform}`,
    handleResponse: toSession,
    handleError: () =>
      Promise.reject('Something went wrong. Please try logging in again.'),
  })),
};

export default SessionService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/session/SessionService.js